import { css } from 'styled-components';
import { TextType, Theme } from '../types';
import { DEFAULT_FONT_STYLE } from './defaultFontStyle';

const ELLIPSIS_VALUES: Record<TextType, number> = {
    h1: 52,
    'h1-medium': 52,
    h2: 44,
    'h2-medium': 44,
    h3: 40,
    'h3-medium': 40,
    h4: 36,
    'h4-medium': 36,
    h5: 32,
    'h5-medium': 32,
    h6: 32,
    'h6-medium': 32,
    'small-text': 20,
    'small-text-bold': 20,
    'small-text-medium': 20,
    'medium-text': 24,
    'medium-text-bold': 24,
    'medium-text-medium': 24,
    'large-text': 28,
    'large-text-bold': 28,
    'large-text-medium': 28,
    'small-button': 16,
    'medium-button': 24,
    caption: 16,
    'caption-smallest': 16,
    'caption-small': 16,
    'caption-medium': 16,
    'caption-bold': 16,
    link: 16,
    overline: 16,
    'option-title-large-text': 28,
    'option-title-medium-text': 24,
    'option-title-small-text': 20,
    'option-subtitle-text': 20,
    'option-label': 16,
    default: 24,
};

export const getEllipsis = (ellipsis: number, type: TextType = 'medium-text') => {
    const maxHeight = (ELLIPSIS_VALUES[type] || ELLIPSIS_VALUES.default) * ellipsis;

    return `
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: ${ellipsis};
        max-height: ${maxHeight}px;
  `;
};

export const getType = (theme: Theme, type: TextType = 'medium-text') => {
    return theme[`lib-${type}`] || DEFAULT_FONT_STYLE[`lib-${type}`] || DEFAULT_FONT_STYLE['lib-default'];
};

export const getSizeResponsiveness = ({
    theme,
    type,
    ellipsis,
}: {
    type?: TextType;
    ellipsis?: number;
    theme: Theme;
}) => {
    const { textTypeResponsiveMap } = theme;

    if (!textTypeResponsiveMap || !type) return null;

    const mediaQueries = Object.keys(textTypeResponsiveMap).map((breakpoint) => {
        const typesMap = textTypeResponsiveMap[breakpoint as keyof typeof textTypeResponsiveMap];
        const newType = typesMap?.[type] || null;

        if (!newType) return null;

        return css`
            @media (min-width: ${breakpoint}) {
                ${getType(theme, newType)};
                ${ellipsis && getEllipsis(ellipsis, newType)}
            }
        `;
    });

    return mediaQueries;
};
